<table mat-table [dataSource]="dataSource" class="w-full">

  <!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->

  <!-- Position Column -->
  <ng-container matColumnDef="taxId">
    <th mat-header-cell *matHeaderCellDef> Tax Id </th>
    <td mat-cell *matCellDef="let element"> {{element.taxId}} </td>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="address">
    <th mat-header-cell *matHeaderCellDef> Address </th>
    <td mat-cell *matCellDef="let element"> {{element.address}} </td>
  </ng-container>

  <!-- Weight Column -->
  <ng-container matColumnDef="country">
    <th mat-header-cell *matHeaderCellDef> Country </th>
    <td mat-cell *matCellDef="let element"> {{element.country}} </td>
  </ng-container>

  <!-- Symbol Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef> Name </th>
    <td mat-cell *matCellDef="let element"> {{element.name}} </td>
  </ng-container>

  <!-- Symbol Column -->
  <ng-container matColumnDef="economicActivity">
    <th mat-header-cell *matHeaderCellDef> Economic Activity </th>
    <td mat-cell *matCellDef="let element"> {{element.economicActivity}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

